import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const MenuTile = (props) => {
  const navigate = useNavigate();

  const goToTileLink = () => {
    if (props.link) navigate(props.link);
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={goToTileLink}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") goToTileLink();
      }}
      title={`${props.label} Listing`}
      className="bg-white dark:bg-white/5 border border-gray-200 dark:border-gray-800 rounded-2xl shadow-md hover:shadow-2xl dark:hover:shadow-2xl dark:hover:shadow-zinc-800 transition-shadow duration-300 p-6 w-full max-w-md cursor-pointer"
    >
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-3">
          <div className="text-blue-600 bg-blue-100 dark:text-blue-300 dark:bg-gray-800 p-3 rounded-lg shadow-inner">
            {props.svg}
          </div>

          <div>
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
              {props.label}
            </p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {props.value}
            </p>
            <p className="text-sm font-semibold text-green-600 dark:text-green-400 mt-1">
              {props.description}
            </p>
          </div>
        </div>

        <div
          className="flex items-center gap-3"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {props.extraEvent && localStorage.getItem("defaultWebForm") && (
            <Link
              to={props.extraEvent}
              target="_blank"
              title="New Application"
              className="text-orange-500 hover:text-orange-600 dark:text-orange-400 dark:hover:text-orange-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
              </svg>
            </Link>
          )}

          <div className="items-center mt-1 border-gray-200 dark:border-gray-700">
            {props.dateRangeBtn}
          </div>
          
          {/* {props.value !== 0 && (
              <Link to={{ pathname: props.link }} title={`${props.label} Listing`}>
                <svg
                  className="w-7 h-7 text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 transition"
                  fill="currentColor"
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M15 22h-2c-1.105 0-2-.895-2-2v-2c0-1.105.895-2 2-2h2c1.105 0 2 .895 2 2v2C17 21.105 16.105 22 15 22zM51 21H24c-1.104 0-2-.896-2-2s.896-2 2-2h27c1.104 0 2 .896 2 2S52.104 21 51 21zM15 35h-2c-1.105 0-2-.895-2-2v-2c0-1.105.895-2 2-2h2c1.105 0 2 .895 2 2v2C17 34.105 16.105 35 15 35zM51 34H24c-1.104 0-2-.896-2-2s.896-2 2-2h27c1.104 0 2 .896 2 2S52.104 34 51 34zM15 48h-2c-1.105 0-2-.895-2-2v-2c0-1.105.895-2 2-2h2c1.105 0 2 .895 2 2v2C17 47.105 16.105 48 15 48zM51 47H24c-1.104 0-2-.896-2-2s.896-2 2-2h27c1.104 0 2 .896 2 2S52.104 47 51 47z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            )} */}
        </div>
      </div>
    </div>
  );
};

export default MenuTile